var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"disabled":this.$store.state.graph_button.selected === this.button_name,"data-graph":this.button_name,"variant":"primary"},on:{"click":_vm.press}},[_vm._v(_vm._s(this.button_text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }